"use strict";
/**
 * Created by hovhannes.ghurshudya on 9/23/2016.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./sis-tab.component.css");
var TabComponent = /** @class */ (function () {
    function TabComponent(titleLabel, idLabel) {
        this.isEnabled = true;
        /**
         * Component shows its content only when its `selected` is true, toggle to show and hide
         * @public
         * @member {boolean}
         * @type {boolean}
         */
        this._selected = false;
        this._titleLabel = titleLabel;
        this._idLabel = idLabel;
        this.isValid = true;
    }
    Object.defineProperty(TabComponent.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (selected) {
            this._selected = selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the input parameter title if exists, otherwise returns the title attribute value
     * @returns {string}
     * @public
     * @method
     */
    TabComponent.prototype.getTitle = function () {
        return ("undefined" === typeof this._title) ? this._titleLabel : this._title;
    };
    /**
     * Returns the input parameter id if exists, otherwise returns the id attribute value
     * @returns {string}
     * @public
     * @method
     */
    TabComponent.prototype.getId = function () {
        return ("undefined" === typeof this._id) ? this._idLabel : this._id;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TabComponent.prototype, "isEnabled", void 0);
    __decorate([
        core_1.Input("title"),
        __metadata("design:type", String)
    ], TabComponent.prototype, "_title", void 0);
    __decorate([
        core_1.Input("id"),
        __metadata("design:type", Object)
    ], TabComponent.prototype, "_id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TabComponent.prototype, "isValid", void 0);
    TabComponent = __decorate([
        core_1.Component({
            
            selector: "sis-tab",
            template: require('./sis-tab.component.html'),
        })
        /**
         * @deprecated use Material tabs instead.
         */
        ,
        __param(0, core_1.Attribute("title")), __param(1, core_1.Attribute("id")),
        __metadata("design:paramtypes", [String, String])
    ], TabComponent);
    return TabComponent;
}());
exports.TabComponent = TabComponent;
//# sourceMappingURL=sis-tab.component.js.map